import { render } from "./InstallPwaAlert.vue?vue&type=template&id=c881c222&scoped=true"
import script from "./InstallPwaAlert.vue?vue&type=script&lang=js"
export * from "./InstallPwaAlert.vue?vue&type=script&lang=js"

import "./InstallPwaAlert.vue?vue&type=style&index=0&id=c881c222&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c881c222"]])

export default __exports__